namespace Roodik.Core
{
	export class ResourceLoader
	{
		public load(provider:ResourceProvider, progressChanged:(progress)=>void, resourcesLoaded:(resources)=>void)
		{
			let baseUrl = (window["cdnUrl"] == null || window["cdnUrl"] == undefined) ? "" : window["cdnUrl"];
			let loader = new PIXI.loaders.Loader();

			for(let i:number = 0; i < provider.sourceList.length; i++)
			{
				loader.add(provider.sourceList[i].name, baseUrl + provider.sourceList[i].url);
			}

			let funcProgress = () =>
			{
				if (progressChanged != null)
				{
					progressChanged(loader.progress);
				}
			};
			loader.on("progress", funcProgress);
			loader.load((loader, resources) =>
			{
				loader.off("progress", funcProgress);
				resourcesLoaded(resources);
			});
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Core/Resources/ResourceLoader.ts